var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29617 13.7037L13.8258 6.17409M9.26027 6.51405C9.26027 5.39337 9.70546 4.31858 10.4979 3.52614C11.2903 2.7337 12.3651 2.28851 13.4858 2.28851C14.6065 2.28851 15.6813 2.7337 16.4737 3.52614C17.2662 4.31858 17.7114 5.39337 17.7114 6.51405C17.7114 7.63473 17.2662 8.70952 16.4737 9.50196C15.6813 10.2944 14.6065 10.7396 13.4858 10.7396M6.51403 9.2603C5.39334 9.2603 4.31856 9.70549 3.52612 10.4979C2.73367 11.2904 2.28849 12.3652 2.28849 13.4858C2.28849 14.6065 2.73367 15.6813 3.52612 16.4737C4.31856 17.2662 5.39334 17.7114 6.51403 17.7114C7.63471 17.7114 8.70949 17.2662 9.50194 16.4737C10.2944 15.6813 10.7396 14.6065 10.7396 13.4858",
    stroke: "#585858",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.da684b9e.svg";
export { ForwardRef as ReactComponent };